import { render, staticRenderFns } from "./vehicleManagement.vue?vue&type=template&id=4d65d0b6&scoped=true&"
import script from "./vehicleManagement.vue?vue&type=script&lang=js&"
export * from "./vehicleManagement.vue?vue&type=script&lang=js&"
import style0 from "./vehicleManagement.vue?vue&type=style&index=0&id=4d65d0b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d65d0b6",
  null
  
)

export default component.exports